import {useState} from 'react'
import {Modal, Tab, Tabs} from 'react-bootstrap'
import {KTSVG, toAbsoluteUrl} from '../../../../../../_metronic/helpers'

const TemplatePreviewPopup = ({
  setBulkMessageData,
  show,
  handleClose,
  templateData,
  bulkMessageData,
}: any) => {
  const [open, setOpen] = useState(false)

  return (
    <>
      <Modal
        id='kt_modal_create_app'
        tabIndex={-1}
        aria-hidden='true'
        dialogClassName='modal-dialog-centered mw-700px h-auto'
        show={show}
        onHide={handleClose}
      >
        <div className=''>
          <div className='modal-header'>
            <h2>Preview</h2>
            <div className='btn btn-icon btn-sm' onClick={handleClose}>
              <KTSVG className='svg-icon-1' path='/media/icons/duotune/arrows/arr061.svg' />
            </div>
          </div>
          <div className='modal-body pt-3'>
            <div className='row d-flex justify-content-between flex-wrap preview-modal'>
              <div className='col-12 col-xl-6 col-lg-6 d-flex col-sm-12'>
                <div
                  className='mobile-bg-wrapper'
                  style={{
                    backgroundImage: `url(${toAbsoluteUrl('/media/mobile/NewMobile.png')})`,
                  }}
                >
                  <div className='inner-content-main'>
                    {templateData?.type == 'MMS' && (
                      <>
                        {/* { ( show?.data?.subjectTitle !== "") ?<div className='messageStyle'> <span>{show?.data?.subjectTitle}</span> </div>:<div className='messageStyle'> <span>{"Engaging Subject title here"}</span></div>} */}

                        <span>
                          <img src={templateData?.media} alt='poster' />
                        </span>
                      </>
                    )}

                    {templateData?.message !== '' ? (
                      <div className='messageStyle'>
                        <span>{templateData?.message}</span>{' '}
                      </div>
                    ) : (
                      <>
                        <span></span>
                      </>
                    )}
                  </div>
                  {/* <div className='wrapper-tabs'>
                  <Tabs
                    defaultActiveKey='notification'
                    className='nav nav-tabs nav-pills border rounded p-2 fs-6 text-dark d-flex justify-content-between'
                  >
                    <Tab eventKey='notification' title='Notification' />
                    <Tab eventKey='message' title='Message' />
                  </Tabs>
                </div> */}
                </div>
              </div>
              <div className='col-12 col-xl-6 col-lg-6 mt-3 col-sm-12'>
                <div className=' mt-3'>
                  <img
                    alt='Logo'
                    src={templateData?.media}
                    className='w-100 mw-150px border-10 rounded'
                  />
                </div>
                <div className='mt-3 d-flex flex-row flex-wrap'>
                  <a className={'badge badge-light-success me-2'}>{templateData?.type}</a>
                  {templateData?.tags?.map((tags: any, i: number) => {
                    return (
                      <a key={i} className={'badge badge-light-primary me-2 mb-2'}>
                        {tags}
                      </a>
                    )
                  })}
                </div>
                <div className='mt-3 w-100 mw-250px'>
                  <p className='previewModal_desc'>{templateData?.message}</p>
                </div>
                <div className='pre-total'>
                  <img
                    src={toAbsoluteUrl('/media/mobile/calandar.svg')}
                    alt='preview'
                    className='me-1'
                  />
                  {templateData?.message?.split('')?.length}
                </div>
                <div className='mt-5 mb-5'>
                  <button
                    className='btn btn-sm btn-light btn-primary me-2 w-100 mw-150px p-3 fw-500'
                    onClick={() => {
                      if (templateData.type == 'MMS') {
                        setBulkMessageData({
                          ...bulkMessageData,
                          message: templateData.message,
                          media: templateData.media,
                          camp_type: templateData.type,
                          gif: templateData.gif,
                          subject: templateData.subjectTitle,
                        })
                        handleClose()
                      } else {
                        setBulkMessageData({
                          ...bulkMessageData,
                          message: templateData.message,
                          media: '',
                          camp_type: templateData.type,
                          gif: '',
                          subject: templateData.subjectTitle,
                        })
                        handleClose()
                      }
                    }}
                  >
                    Use this template
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default TemplatePreviewPopup
